import React from 'react';
import { IconProps } from './types';

export function LoadingIcon(props: IconProps) {
	const { width, height, stroke } = props;
	return (
		<svg
			className="animate-spin"
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			stroke={stroke}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path d="M21 12a9 9 0 1 1-6.219-8.56" />
		</svg>
	);
}
